import script from "./DataPrivacyOverlayComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataPrivacyOverlayComponent.vue?vue&type=script&lang=ts&setup=true"

import "./DataPrivacyOverlayComponent.vue?vue&type=style&index=0&id=04be1e0b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04be1e0b"]])

export default __exports__